import { actionDone, actionRequest } from '../action-helpers';
import { initEntity } from '@/common/lib/entity-module';
import { openSuccessDialog } from '@/common/components/kf-dialog';
import { errorHandler } from '../ajax';

export const getInformRequest = actionRequest('@@informOwner/GET_INFORM_REQUEST');
export const getInformSuccess = actionDone('@@informOwner/GET_INFORM_SUCCESS', (res) => [
  initEntity({ target: 'status', data: res.status }),
  initEntity({ target: 'msgText', data: res.inform.msgText }),
  initEntity({ target: 'date', data: res.inform.date }),
]);
export const getInformFailure = actionDone('@@informOwner/GET_INFORM_FAILURE', (res) => [
  initEntity({ target: 'status', data: res.status }),
]);

export const informOwnerRequest = actionRequest('@@pay/INFORM_OWNER_REQUEST');
export const informOwnerSuccess = actionDone('@@pay/INFORM_OWNER__SUCCESS', () => [
  openSuccessDialog('送信しました。')
]);
export const informOwnerFailure = actionDone('@@pay/INFORM_OWNER__FAILURE', err => [errorHandler(err)]);